

import { create } from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const useCategoryStore = create((set, get) => ({
  categories: [],
  errors: [],
  selectedCategory: null,
  getCategories: async () => {
    const response = await fetch(`${ProductsAPI}/categories`);
    if (!response.ok) {
      const error = await response.text();
      set({ errors: [...get().errors, error] });
      return;
    }
    try {
      const data = await response.json();
      set({ categories: data, errors: [] });
    } catch (error) {
      set({ errors: [...get().errors, "Failed to parse categories"] });
    }
  },
  setSelectedCategory: (category) => {
    set({ selectedCategory: category });
  }
  
}));

export default useCategoryStore;
